module.exports = __webpack_public_path__ + "static/media/tooth.a298bd50.svg";